/** Canonical WB region names shared by warehouse mapping and column catalogs. */
export const CENTRAL = "Центральный федеральный округ";
export const NORTHWEST = "Северо-Западный федеральный округ";
export const VOLGA = "Приволжский федеральный округ";
export const URAL = "Уральский федеральный округ";
export const SIBERIA = "Сибирский федеральный округ";
export const FAREAST = "Дальневосточный федеральный округ";
export const SOUTH = "Южный федеральный округ";
export const CAUCASUS = "Северо-Кавказский федеральный округ";

/** Восемь федеральных округов РФ — всё остальное считаем зарубежным. */
export const RU_FEDERAL_OKRUGS = new Set([
  "Центральный федеральный округ",
  "Северо-Западный федеральный округ",
  "Южный федеральный округ",
  "Северо-Кавказский федеральный округ",
  "Приволжский федеральный округ",
  "Уральский федеральный округ",
  "Сибирский федеральный округ",
  "Дальневосточный федеральный округ",
]);

/** Единый регион для зарубежья (Беларусь/Казахстан/Армения/Узбекистан…). */
export const FOREIGN_REGION = "Зарубежные";

/** All standard choices stay visible before a WB store has data. */
export const WB_CATALOG_REGIONS = [...RU_FEDERAL_OKRUGS, FOREIGN_REGION];
